import { PortfolioPhaseDates } from "../../../../../models";

const toDate = (value?: string | Date | null): Date | undefined => {
  if (!value) return undefined;
  return value instanceof Date ? value : new Date(value);
};

export const hasOverlappingDates = (dates: Record<string, PortfolioPhaseDates>): boolean => {
  const ranges = Object.values(dates)
    .map((phase) => {
      const start = toDate(phase.start);
      const end = toDate(phase.end ?? phase.start);
      if (!start || !end) return undefined;
      return {
        start: start.getTime(),
        end: end.getTime(),
      };
    })
    .filter((range): range is { start: number; end: number } => !!range)
    .sort((a, b) => a.start - b.start);

  let currentEnd = -Infinity;

  return ranges.some((range) => {
    if (range.start < currentEnd) return true;
    currentEnd = Math.max(currentEnd, range.end);
    return false;
  });
};
